import _ from 'lodash';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import ApplicationContext from '../../ApplicationContext';
import { nowDate } from '../../dateUtils';
import Label from '../../ui/Label';
import { useMyTask } from '../myTask/MTTaskListView';

type TaskBoardCounts = {
  pickupAvailableCnt: number;
  lfdRiskCnt: number;
  gateOutCnt: number;
  detentionRiskCnt: number;
  etaChangeCnt: number;
  taskMemoCnt: number;

  pickupIds: number[];
  lfdRiskIds: number[];
  gateOutIds: number[];
  detentionIds: number[];
  etaIds: number[];
  taskMemoIds: number[];
};

const BoardStyle =styled.div`
  .dashboard {
      height: 292px;
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      grid-template-rows: repeat(2, 1fr);
      gap: 12px;
  }
`;

const TaskBoardBox = styled.div<{$isDark: boolean}>`
    background: ${props => (props.$isDark ? '#171b1d': '#dce7e5')};
    border: ${props => (props.$isDark ? '1px solid #394347' : '1px solid #b6c7c4')};
    border-radius: 7px;
    padding: 16px 18px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: .15s ease;
    box-shadow: 0 1px 3px rgba(30, 60, 70, .06);
  
  &:hover {
      transform: translateY(-1px);
      border-color: ${props => (props.$isDark ? '#6f8388':'#8fb8b0')};
      background: ${props => (props.$isDark ? '#1b2022': '#e7efee')};
      box-shadow: 0 3px 9px rgba(30,60,70, .10);
  }

  .metric .count {
      font-size: 30px;
      font-weight: 700;
      line-height: 1;
      color: ${props => (props.$isDark ? '#f5f7f8' : '#1e2a2f')};
  }

  .metric .bar {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 5px;
  }

  .metric .top {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
  }

  .metric .desc {
      font-size: 11px;
      line-height: 1.35;
      color: ${props => (props.$isDark? '#FFF': '#6a787d')};
      margin-top: 10px;
  }

  .metric .link {
      position: absolute;
      bottom: 13px;
      right: 15px;
      font-size: 11px;
      color: ${props => (props.$isDark? '#dce8ea': '#177a91')};
      font-weight: 700;
  }

  .metric .label {
      font-size: 14px;
      font-weight: 700;
      color: ${props => (props.$isDark ? '#f5f7f8' : '#23343a')};
  }


  .blue .bar {
      background: #4d7fd1;
  }
  .amber .bar {
      background: #bf7f18;
  }

  .green .bar {
      background: #2f9f5b;
  }

  .red .bar {
      background: #c94e45;
  }

  .cyan .bar {
      background: #1387a8;
  }

  .barpurple .bar {
      background: #7a62b7;
  }

`;

// Home 재진입 시 다시 조회하지 않도록 마지막 결과를 보관 (Refresh를 누를 때만 갱신)
// 사용자나 날짜가 바뀌면 키가 달라져서 자동으로 다시 조회함
// 브라우저 새로고침(F5)이나 새 탭에서는 비워짐
let cachedCounts: TaskBoardCounts | null = null;
let cachedKey = '';

export function invalidateTaskBoard() {
  cachedKey = '';   // 키를 비우면 다음 Home 진입 때 다시 조회
}

function TaskBoard() {
  const appContext = useContext(ApplicationContext);
  const cacheKey = `${appContext.user?.id ?? ''}_${nowDate()}`;
  const [counts, setCounts] = useState<TaskBoardCounts | null>(
    cachedKey === cacheKey ? cachedCounts : null
  );
  const [loading, setLoading] = useState(false);
  const reqIdRef = useRef(0);
  const {switchToMyTask} = useMyTask();

  const loadCounts = useCallback(async () => {
    const reqId = ++reqIdRef.current;   // 연속 클릭 시 마지막 요청 결과만 반영
    setLoading(true);
    try {
      const data = await appContext.api.getTaskBoardCounts(3,2, nowDate());
      cachedCounts = data.result;       // 다음 진입 때 재사용
      cachedKey = cacheKey;
      if (reqId === reqIdRef.current) setCounts(data.result);
    } catch (err) {
      console.error('Failed to load task board counts:', err);
    } finally {
      if (reqId === reqIdRef.current) setLoading(false);
    }
  }, [cacheKey]);




  // 저장된 결과가 없을 때만 자동 조회 (재진입 시에는 Refresh로만 갱신)
  useEffect(() => {
    if (cachedKey !== cacheKey) loadCounts();
    return () => { reqIdRef.current++; };  // 언마운트 후 도착한 응답 무시
  }, [loadCounts, cacheKey]);

  return (
    <div style={{marginTop: '20px' }}>
      <div style={{ width: '1446px' }}>
        <div style={{display:'flex', justifyContent:'space-between'}}>
          <div style={{display: 'flex', flexDirection: 'row', padding: '4px 0px 0px 0px', gap: '8px', marginBottom:'10px'}}>
          {/* <img width='20px' height='20px' src={taskBoardPinkIcon} />  */}
          <div style={{ backgroundColor: appContext.useDarkMode ? '#47BDD3' : '#0079A4', width: '3px', height: '16px', borderRadius: '1px'}} />
          <Label style={{ color: appContext.useDarkMode ? 'white' : 'black', fontSize: '14px', lineHeight: '16px' }} bold label={`Task Board`} />
          </div>
          <div>
            <button   onClick={loadCounts} disabled={loading} style={{float: 'right', borderRadius: 4, padding: "6px 11px", fontSize: 12, cursor: "pointer", 
              color: appContext.useDarkMode ? "#58c7d8" : "#1387a8", border: appContext.useDarkMode ? "1px solid #3f5e64" : "1px solid #a9c9cf" , background: appContext.useDarkMode ? "#162126" : "#ffffff",}}>
                ↻ Refresh
              </button>
          </div>
        </div>
      <BoardStyle>
        <div className='dashboard'>
        <TaskBoardBox $isDark= {appContext.useDarkMode} onClick={() => switchToMyTask(counts?.pickupIds, 1)}>
        <div className="metric amber">
          <div className="bar"/>
            <div className="top">
              <div className="label">1&nbsp; Pickup Available</div>
              <div className="count">{counts?.pickupAvailableCnt ?? 0}</div>
            </div>
            <div className="desc">Available cargo requiring pickup / appointment action.</div>
            <div className="link">Open in My Task →</div>
        </div>
        </TaskBoardBox>
         <TaskBoardBox $isDark= {appContext.useDarkMode} onClick={() => switchToMyTask(counts?.gateOutIds, 3)}>
            <div className="metric green">
            <div className="bar"></div>
            <div className="top"><div className="label">3&nbsp; Gate Out / Movement</div>
            <div className="count">{counts?.gateOutCnt ?? 0}</div></div>
            <div className="desc">Container gated out / key movement milestone.</div>
            <div className="link">Open in My Task →</div></div>
          </TaskBoardBox>
           <TaskBoardBox $isDark= {appContext.useDarkMode} onClick={() => switchToMyTask(counts?.etaIds, 5)}>
            <div className="metric blue">
              <div className="bar"></div><div className="top"><div className="label">5&nbsp; ETA Change</div>
              <div className="count">{counts?.etaChangeCnt ?? 0}</div></div><div className="desc">ETA / F.ETA changed; review downstream schedule impact.</div>
              <div className="link">Open in My Task →</div></div>
              </TaskBoardBox>
               <TaskBoardBox $isDark= {appContext.useDarkMode} onClick={() => switchToMyTask(counts?.lfdRiskIds, 2)}>
            <div className="metric red">
              <div className="bar"></div><div className="top">
              <div className="label">2&nbsp; Demurrage / LFD Risk</div><div className="count">{counts?.lfdRiskCnt ?? 0}</div>
              </div><div className="desc">Risk created after availability if pickup is delayed.</div><div className="link">Open in My Task →</div></div>
              </TaskBoardBox>
            <TaskBoardBox $isDark= {appContext.useDarkMode} onClick={() => switchToMyTask(counts?.detentionIds, 4)}>
              <div className="metric barpurple" >
                <div className="bar"></div><div className="top"><div className="label">4&nbsp; Detention / Empty Return Risk</div>
              <div className="count">{counts?.detentionRiskCnt ?? 0}</div></div><div className="desc">Risk created after gate-out if empty return is delayed.</div>
              <div className="link">Open in My Task →</div></div>
            </TaskBoardBox>
             <TaskBoardBox $isDark= {appContext.useDarkMode} onClick={() => switchToMyTask(counts?.taskMemoIds, 6)}>
              <div className="metric cyan">
              <div className="bar"></div>
              <div className="top"><div className="label">6&nbsp; Task Memo</div>
              <div className="count">{counts?.taskMemoCnt ?? 0}</div></div>
              <div className="desc">Only events with user-entered Task/Memo text.</div>
              <div className="link">Open in My Task →</div></div>
            </TaskBoardBox>
      </div>
      </BoardStyle>
  </div>
  </div>
  );
}

export default TaskBoard;